import { Dictionary } from "../dictionary";
import { SizeClassification } from "./_types";
import { LIB_CLASSIFICATIONS_FRUT_HARVEST } from "./classifications_frut_harvest";

export class ClassificationsDictionary extends Dictionary<SizeClassification>{
    constructor(){
        super([
            ...LIB_CLASSIFICATIONS_FRUT_HARVEST,
        ]);
    }
}